module.exports = __webpack_public_path__ + "static/scientist8-b4e13551932c24fdb71c422db74ba4f3.png";